/** @jsx jsx */
import { useEffect, useState } from 'react'
import { jsx, Box } from 'theme-ui'
import { useMapboxContext } from '../useMapboxContext'
import { Button } from 'components/buttons/Button'

const PitchControl = React.forwardRef(({ children, type = 'plus' }, ref) => {
  const { map } = useMapboxContext()
  const [pitch, setPitch] = useState('2d')

  const handleClick = () => {
    map.current.easeTo({
      pitch: pitch === '2d' ? 66 : 0,
      duration: 750,
    })
    setPitch(pitch === '2d' ? '3d' : '2d')
  }

  useEffect(() => {
    const onMoveEnd = () => {
      setPitch(map.current.getPitch() > 0 ? '3d' : '2d')
    }
    map.current.on('moveend', onMoveEnd)
    return () => map.current.off('moveend', onMoveEnd)
  }, [])

  return (
    <Button
      ref={ref}
      sx={{
        position: 'relative',
        backgroundColor: 'black',
        width: '48px',
        height: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        borderColor: 'red',
        mt: 3,
      }}
      onClick={handleClick}
    >
      {/* Make {pitch === '2d' ? '3d' : '2d'} */}
      <div
        className="scene"
        sx={{
          // position: 'fixed',
          // zIndex: 99999999,
          top: 0,
          left: 0,
          width: '20px',
          height: '20px',
          // perspective: '400px',
          transformOrigin: '0 0',
        }}
      >
        <Box
          sx={{
            width: '24px',
            height: '24px',
            position: 'relative',
            transformStyle: 'preserve-3d',
            transform:
              pitch === '3d'
                ? 'rotateX(0) rotateY(0)'
                : 'translateY(-2px) rotateX(-45deg) rotateY(45deg)',
            // transform: 'rotate3d(0, 0, 1, 90deg)', //translateZ(-12px)
            transition: ' transform 750ms',
          }}
        >
          <CubeFace transform="rotateY(0deg) translateZ(9px)"></CubeFace>
          <CubeFace transform="rotateY(90deg) translateZ(9px)"></CubeFace>
          <CubeFace transform="rotateY(180deg) translateZ(9px)"></CubeFace>
          <CubeFace transform="rotateY(-90deg) translateZ(9px)"></CubeFace>
          <CubeFace transform="rotateX(90deg) translateZ(9px)"></CubeFace>
          <CubeFace transform="rotateX(-90deg) translateZ(9px)"></CubeFace>
        </Box>
      </div>
    </Button>
  )
})

const CubeFace = ({ transform, children }) => (
  <Box
    sx={{
      position: 'absolute',
      width: '20px',
      height: '20px',
      backgroundColor: 'black',
      border: '2px solid',
      borderColor: 'red',
      transform: transform,
    }}
  >
    {children}
  </Box>
)

export { PitchControl }
